import { EnvironmentOutlined, SaveOutlined } from '@ant-design/icons';
import { Alert, Button, Form, Input, InputNumber, Modal, Select, Tooltip, } from 'antd';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { default as EmailTag, default as InputTag, } from '../../components/InputTag';
import LinkTag from '../../components/LinkTag';
import LocationSearchLocationIQ from '../../components/LocationSearchLocationIQ';
import PhoneTag from '../../components/PhoneTag';
import { EDEVICETYPE } from '../../constants';
import * as SERVICE from '../../constants/service.types';
import regex from '../../constants/system.keys';
import { socketEmitEvent } from '../../redux/actions';
import { uniqRequestId } from '../../untils/unique';
import FindLocationMap from './FindLocationMap';

const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 },
};

const UpdateCameraComponent = ({
  onUpdate,
  data,
  updateDataReturn,
  onCancel,
}) => {
  const { t } = useTranslation();
  const { namespace, accountByNamespace, listGpsLocation, listSpeakerSip } =
    useSelector((state) => state);
  const [isLoad, setIsLoad] = useState(false);
  const [form] = Form.useForm();
  const [isBlock, setIsBlock] = useState(false);
  const dispatch = useDispatch();
  const [address, setAddress] = useState({
    note: '',
    lat: 0,
    lng: 0,
  });
  const [alertUpdate, setAlertUpdate] = useState({
    visible: false,
    type: null,
    message: null,
  });

  const [updateReturn, setUpdateReturn] = useState();
  const [isModalOpenMap, setIsModalOpenMap] = useState(false);
  const [keyMap, setKeyMap] = useState(Math.random());
  const [isLoadingLatLng, setIsLoadingLatLng] = useState(false);

  useEffect(() => {
    if (namespace) {
      let data = {
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_ACCOUNT_BY_NAMESPACE,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      dispatch(socketEmitEvent(dataObj));
    }
  }, [dispatch, namespace]);

  useEffect(() => {
    if (updateDataReturn) {
      setUpdateReturn(updateDataReturn);
    }
  }, [updateDataReturn]);
  useEffect(() => {
    if (form && data) {
      const { name, serial, note, lat, lng, tags } = data;
      setAddress({
        note,
        lat,
        lng,
      });
      const contact = (data?.contact && JSON.parse(data?.contact)) || {};
      form.setFieldsValue({
        name,
        serial,
        tags: tags && tags !== ';' ? tags?.split(';') : [],
        location: note,
        accounts: contact?.accounts ? contact?.accounts?.split(';') : [],
        gps: contact?.gps ? contact?.gps?.split(';') : [],
        speaker: contact?.speaker ? contact?.speaker?.split(';') : [],
        phones: contact?.phones ? contact?.phones?.split(';') : [],
        emails: contact?.emails ? contact?.emails?.split(';') : [],
        subSources:
          (data?.subSources &&
            JSON.parse(data?.subSources)?.map((item) => item.source)) ??
          [],
        lat,
        lng,
      });
    }
    return () => {
      setAlertUpdate({ visible: false });
      form.resetFields();
    };
  }, [data, form]);

  const handleAddressChange = (address) => {
    form.setFieldsValue({
      location: address,
    });
    setAddress((state) => ({
      ...state,
      note: address,
    }));
  };

  const handleSelect = (address) => {
    form.setFieldsValue({
      location: address?.note ?? '',
    });
    setAddress(address);
    if (address?.lat && address?.lng) {
      form.setFieldsValue({
        lat: address?.lat,
        lng: address?.lng,
      });
    }
  };

  useEffect(() => {
    if (data && updateReturn && updateReturn.serial === data.serial) {
      setIsLoad(false);
      setUpdateReturn(null);
      if (!updateReturn.isSuccess) {
        setAlertUpdate({
          visible: true,
          type: 'warning',
          message: t('Something went wrong, try again!!'),
        });
      }
    }
  }, [data, dispatch, t, updateDataReturn, updateReturn]);

  const handleOnUpdate = (values) => {
    const contact = {
      phones: values.phones?.join(';') || '',
      accounts: values.accounts?.join(';') || '',
      gps: values.gps?.join(';') || '',
      speaker: values.speaker?.join(';') || '',
      emails: values.emails?.join(';') || '',
    };
    const dataUpdate = {
      name: values.name,
      note: values.location ?? '',
      serial: values.serial,
      lat: values?.lat || 0,
      lng: values?.lng || 0,
      contact: JSON.stringify({ ...contact }),
      tags: values.tags?.join(';')?.toLowerCase() || ';',
    };
    let dataSubSources = [];
    // eslint-disable-next-line no-unused-expressions
    values.subSources?.map((item) => {
      const checkData = (
        data?.subSources && JSON.parse(data?.subSources)
      )?.find((item1) => item1.source === item);
      if (checkData) {
        dataSubSources = [...dataSubSources, { ...checkData }];
      } else {
        dataSubSources = [...dataSubSources, { source: item }];
      }
    });
    if (values.subSources) {
      let data1 = {
        namespace,
        serial: values.serial,
        subSources: JSON.stringify(dataSubSources),
      };
      let dataObj1 = {
        appServiceType: SERVICE.ADD_SUB_STREAM_CAMERA,
        requestId: new Date().getTime(),
        body: JSON.stringify(data1),
      };
      dispatch(socketEmitEvent(dataObj1));
    }
    setIsLoad(true);
    return onUpdate(dataUpdate);
  };

  const showModal = () => {
    setIsModalOpenMap(true);
  };

  const handleOk = () => {
    setIsModalOpenMap(false);
  };

  const handleCancel = () => {
    setIsModalOpenMap(false);
    setKeyMap(Math.random());
  };

  const handleFindLocationChange = (latlng) => {
    if (latlng?.lat && latlng?.lng) {
      form.setFieldsValue({
        lat: latlng?.lat,
        lng: latlng?.lng,
      });
      setAddress((state) => ({
        ...state,
        lat: latlng?.lat,
        lng: latlng?.lng,
      }));
    }
  };

  const handleLinkSpeaker = (action, serial) => {
    const dataBody = {
      namespace,
      providerNamespace: null,
      fromSerial: data.serial,
      toSerial: serial,
    };

    const dataObj = {
      appServiceType: action === 'select' ? SERVICE.LINK_DEVICE : SERVICE.UN_LINK_DEVICE,
      requestId: new Date().getTime(),
      body: JSON.stringify(dataBody),
    };
  }

  useEffect(() => {
    if (namespace) {
      let dataBodyGps = {
        namespace,
        timeRequest: uniqRequestId(19, EDEVICETYPE.GPS),
        deviceType: EDEVICETYPE.GPS,
        page: 0,
        size: -1,
      };

      let dataObjGps = {
        appServiceType: SERVICE.LIST_ALL_DEVICE_BY_PAGE,
        requestId: new Date().getTime(),
        body: JSON.stringify(dataBodyGps),
      };
      let dataBodySpeaker = {
        namespace,
        timeRequest: uniqRequestId(19, EDEVICETYPE.SPEAKER),
        deviceType: EDEVICETYPE.SPEAKER,
        page: 0,
        size: -1,
      };

      let dataObjSpeaker = {
        appServiceType: SERVICE.LIST_ALL_DEVICE_BY_PAGE,
        requestId: new Date().getTime(),
        body: JSON.stringify(dataBodySpeaker),
      };

      dispatch(socketEmitEvent(dataObjGps));
      dispatch(socketEmitEvent(dataObjSpeaker));
    }
  }, [dispatch, namespace]);

  return (
    <div className="edit-camera-component">
      <Form
        form={form}
        {...layout}
        name="form_edit_camera"
        onFinish={(values) => handleOnUpdate(values)}
      >
        <Form.Item
          name="name"
          label={t('Name')}
          rules={[
            {
              required: true,
              message: t('Please input the name of the camera!'),
            },
            {
              pattern: regex.isName,
              message: t('Please enter only letters and numbers!'),
            },
            {
              max: 80,
              message: t('Please input up to 80 characters!'),
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="serial"
          label={t('Serial')}
          rules={[
            {
              required: true,
              message: t('Please input the serial of the camera!'),
            },
            {
              pattern: regex.isName,
              message: t('Please enter only letters and numbers!'),
            },
            {
              max: 80,
              message: t('Please input up to 80 characters!'),
            },
          ]}
        >
          <Input disabled={true} />
        </Form.Item>
        <div
          style={{
            display: 'flex',
            alignItems: 'baseline',
            justifyContent: 'center',
          }}
        >
          <Form.Item
            name="location"
            rules={[
              {
                pattern: regex.isName,
                message: t('Please enter only letters and numbers!'),
              },
              {
                max: 200,
                message: t('Please input up to 200 characters!'),
              },
            ]}
            label={t('Location')}
            style={{ width: '95%' }}
          >
            <LocationSearchLocationIQ
              address={address?.note}
              onChange={handleAddressChange}
              onAddressSelect={handleSelect}
              setIsLoadingLatLng={setIsLoadingLatLng}
              setIsBlock={setIsBlock}
              namespace={namespace}
            />
          </Form.Item>
          <div style={{ marginLeft: '5px' }}>
            <Tooltip title={t('Add lat lng')}>
              <EnvironmentOutlined
                style={{ fontSize: '20px' }}
                onClick={() => showModal()}
              />
            </Tooltip>
          </div>
        </div>
        <Form.Item name="lat" label={t('Lat')}>
          <InputNumber style={{ width: '100%' }} disabled={isLoadingLatLng} />
        </Form.Item>
        <Form.Item name="lng" label={t('Lng')}>
          <InputNumber style={{ width: '100%' }} disabled={isLoadingLatLng} />
        </Form.Item>
        <Form.Item
          label={t('Source')}
          name="subSources"
          className="edit-camera-email"
          style={{ borer: '1px solid #434343', borderRadius: '2px' }}
        >
          <LinkTag
            nameAdd={t('Add source')}
            gatewaySerial={data?.gatewaySerial}
            namespace={namespace}
            dataSubSources={data?.subSources && JSON.parse(data?.subSources)}
          />
        </Form.Item>
        <Form.Item name="gps" label={t('Gps')}>
          <Select
            showSearch
            mode="multiple"
            placeholder={t('Select Gps')}
            optionFilterProp="children"
            filterOption={(input, option) => {
              return (
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              );
            }}
          >
            {listGpsLocation?.map((d) => (
              <Select.Option key={d.serial}>
                {d.name ? d.name : d.serial}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name="speaker" label={t('Speaker')}>
          <Select
            showSearch
            mode="multiple"
            placeholder={t('Select Speaker')}
            optionFilterProp="children"
            filterOption={(input, option) => {
              return (
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              );
            }}
            onSelect={value => handleLinkSpeaker('select', value)}
            onDeselect={value => handleLinkSpeaker('deselect', value)}
          >
            {listSpeakerSip?.map((d) => (
              <Select.Option key={d.serial}>
                {d.name ? d.name : d.serial}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="phones"
          className="edit-camera-email"
          label={t('Phone')}
          style={{ borer: '1px solid #434343', borderRadius: '2px' }}
        >
          <PhoneTag />
        </Form.Item>
        <Form.Item name="accounts" label={t('Account')}>
          <Select
            showSearch
            mode="multiple"
            placeholder={t('Select account')}
            optionFilterProp="children"
            filterOption={(input, option) => {
              const data =
                (option &&
                  option.children &&
                  option.children.props &&
                  option.children.props.children &&
                  option.children.props.children[0] &&
                  option.children.props.children[0].props &&
                  option.children.props.children[0].props.children) ||
                '';
              return (
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              );
            }}
          >
            {accountByNamespace?.map((d) => (
              <Select.Option key={d.accountId}>
                {d.fullName
                  ? `${d.phonenumber} (${d.fullName})`
                  : d.phonenumber}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="emails"
          className="edit-camera-email"
          label={t('Email')}
          style={{ borer: '1px solid #434343', borderRadius: '2px' }}
        >
          <EmailTag numberTag={3} nameAdd="Add email" />
        </Form.Item>
        <Form.Item
          name="tags"
          className="edit-camera-email"
          label={t('Tag')}
          style={{ borer: '1px solid #434343', borderRadius: '2px' }}
        >
          <InputTag numberTag={3} nameAdd="Add tag" />
        </Form.Item>
        <div className="edit-camera-alert">
          {alertUpdate.visible && (
            <Alert
              {...alertUpdate}
              showIcon
              closable
              onClose={() => setAlertUpdate({ visible: false })}
            />
          )}
        </div>
        <div className="btn-update-camera">
          <Button onClick={() => onCancel()}>{t('Cancel')}</Button>
          <Form.Item shouldUpdate={true}>
            {() => (
              <Button
                icon={<SaveOutlined />}
                htmlType="submit"
                type="primary"
                loading={isLoad}
              >
                {t('Update')}
              </Button>
            )}
          </Form.Item>
        </div>
      </Form>
      <Modal
        title={t('Add lat lng')}
        visible={isModalOpenMap}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={false}
        width={'50%'}
      >
        <FindLocationMap
          key={keyMap}
          handleFindLocationChange={handleFindLocationChange}
          handleCancel={handleCancel}
        />
      </Modal>
    </div>
  );
};

export default UpdateCameraComponent;
